export const CleanerTaskSummaryTypes = {
    GET_JOB_DETAILS: 'GET_JOB_DETAILS',
    CLEAR_JOB_DETAILS: 'CLEAR_JOB_DETAILS',
    GET_LOCATION_LIST: 'GET_LOCATION_LIST',
    CLEAR_LOCATION_LIST: 'CLEAR_LOCATION_LIST',
};
